// extracted by mini-css-extract-plugin
export var sliderRange = "_ql-2";
export var sliderRoot = "_ql-0";
export var sliderThumb = "_ql-3";
export var sliderTrack = "_ql-1";